export const services = [
  {
    id: 1,
    slug: "draught-survey",
    title: "Draught Survey",
    description: "Accurate measurement and calculation of cargo quantity loaded or discharged from vessels.",
    icon: "Ship",
    heroImage: "https://images.pexels.com/photos/5756891/pexels-photo-5756891.jpeg?auto=compress&cs=tinysrgb&w=1600",
    overview:
      "Our draught survey support focuses on practical cargo quantity verification with careful vessel reading, sounding checks, and clear reporting for charterers, owners, and operators.",
    intro:
      "NH Marine Services provides draught survey assistance for loading and discharge operations with attention to detail, transparent communication, and dependable documentation.",
    highlights: [
      "Suitable for loading and discharge quantity verification",
      "Clear reporting to support commercial decision-making",
      "Focused coordination with vessel and terminal teams"
    ],
    details: [
      "Pre-loading and post-loading surveys",
      "Cargo weight determination",
      "Vessel stability assessment",
      "Detailed survey reports"
    ]
  },
  {
    id: 2,
    slug: "bunker-survey",
    title: "Bunker Survey",
    description: "Precise measurement and documentation of fuel quantities during bunkering operations.",
    icon: "Fuel",
    heroImage: "https://images.pexels.com/photos/10020724/pexels-photo-10020724.jpeg?auto=compress&cs=tinysrgb&w=1600",
    overview:
      "Our bunker survey service is designed to help vessel interests monitor fuel quantity during delivery with reliable observation, quantity checks, and straightforward reporting.",
    intro:
      "We support bunker quantity verification by helping record key measurements, coordinating observations onboard, and preparing documentation in a clear and timely format.",
    highlights: [
      "Quantity verification during bunkering operations",
      "Support for clearer fuel-related documentation",
      "Responsive communication during time-sensitive operations"
    ],
    details: [
      "Bunker quantity verification",
      "Quality analysis",
      "Documentation and reporting",
      "Dispute resolution support"
    ]
  },
  {
    id: 3,
    slug: "p-and-i-services",
    title: "P&I Services",
    description: "Protection and Indemnity services including surveys and consultancy for maritime incidents.",
    icon: "Shield",
    heroImage: "/p&i.avif",
    overview:
      "Our P&I support services are intended to assist principals with factual site observations, condition checks, and timely reporting when incidents or operational concerns arise.",
    intro:
      "We aim to provide dependable on-ground assistance for marine incidents by documenting conditions carefully and sharing information clearly with all relevant parties.",
    highlights: [
      "Practical support for incident-related inspections",
      "Clear factual reporting and visual observations",
      "Useful coordination during sensitive operational matters"
    ],
    details: [
      "Incident investigation",
      "Cargo damage assessment",
      "Hull damage surveys",
      "Expert witness services"
    ]
  },
  {
    id: 4,
    slug: "condition-survey",
    title: "Condition Survey",
    description: "Comprehensive vessel and cargo condition assessment for insurance and pre-purchase purposes.",
    icon: "ClipboardCheck",
    heroImage: "https://images.pexels.com/photos/5943939/pexels-photo-5943939.jpeg?auto=compress&cs=tinysrgb&w=1600",
    overview:
      "Our condition survey work is focused on documenting the visible state of vessels, cargo, or equipment with organized inspection notes and practical reporting.",
    intro:
      "Whether the requirement is operational review, cargo condition recording, or a general vessel check, we aim to provide a structured survey approach and a clear outcome.",
    highlights: [
      "Useful for pre-operation and condition documentation",
      "Focused visual inspection and reporting",
      "Suitable for owners, operators, and commercial stakeholders"
    ],
    details: [
      "Pre-purchase surveys",
      "Vessel condition reports",
      "Cargo condition inspection",
      "Insurance surveys"
    ]
  },
  {
    id: 5,
    slug: "on-off-hire-survey",
    title: "On/Off Hire Survey",
    description: "Detailed vessel inspection at the start and end of charter periods.",
    icon: "FileText",
    heroImage: "https://images.pexels.com/photos/19698686/pexels-photo-19698686.jpeg?auto=compress&cs=tinysrgb&w=1600",
    overview:
      "Our on-hire and off-hire survey support helps record vessel condition, bunkers, and operational observations at key charter transition points.",
    intro:
      "We provide practical assistance in documenting vessel status at delivery and redelivery, helping principals maintain a clear survey record during charter movement.",
    highlights: [
      "Condition recording at delivery and redelivery stages",
      "Useful bunker and equipment observation support",
      "Clear reporting to help reduce later uncertainty"
    ],
    details: [
      "Vessel condition documentation",
      "Bunker ROB verification",
      "Equipment inventory",
      "Charter party compliance"
    ]
  },
  {
    id: 6,
    slug: "marine-consultancy",
    title: "Marine Consultancy",
    description: "Expert advice and guidance on maritime operations, compliance, and best practices.",
    icon: "Users",
    heroImage: "https://images.pexels.com/photos/18676400/pexels-photo-18676400.jpeg?auto=compress&cs=tinysrgb&w=1600",
    overview:
      "Our marine consultancy support is centered on practical guidance, operational coordination, and helping clients approach marine requirements with clarity.",
    intro:
      "As a growing marine services company, we focus on responsive consultancy support, clear communication, and service availability across South India ports while gradually expanding into other states.",
    highlights: [
      "Operational guidance with a practical approach",
      "Responsive communication from a dependable team",
      "Support tailored to the client’s immediate requirement"
    ],
    details: [
      "Operational consultancy",
      "Compliance advisory",
      "Risk management",
      "Training and development"
    ]
  },
  {
  id: 7,
  slug: "compass-adjustment",
  title: "Compass Adjustment",
  description: "Professional magnetic compass adjustment and calibration services ensuring accurate navigation and compliance with maritime standards.",
  icon: "Compass",
  heroImage: "/compass%20adjustment.png",
  overview:
    "Our compass adjustment support focuses on helping vessels maintain reliable magnetic compass performance through careful checking, observation, and reporting.",
  intro:
    "We provide compass adjustment assistance with attention to onboard conditions, deviation observations, and practical documentation for navigational reference.",
  highlights: [
    "Support for compass checking and adjustment activity",
    "Useful onboard observation and deviation recording",
    "Clear reporting for operational follow-up"
  ],
  details: [
    "Magnetic compass deviation correction",
    "Onboard compass calibration",
    "Deviation card preparation",
    "Error analysis and reporting",
    "Compliance with IMO standards"
  ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Captain James Anderson",
    position: "Fleet Manager, Global Shipping Co.",
    content: "NH Marine Services has been our trusted partner for over 5 years. Their draught survey accuracy and professionalism are unmatched.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Mitchell",
    position: "Operations Director, Maritime Logistics Ltd",
    content: "Excellent bunker survey services. Their detailed reports and quick turnaround times have helped us resolve disputes efficiently.",
    rating: 5
  },
  {
    id: 3,
    name: "David Chen",
    position: "Marine Superintendent, Ocean Carriers",
    content: "Professional, reliable, and thorough. NH Marine Services consistently delivers high-quality surveys and consultancy.",
    rating: 5
  }
];

export const projects = [
  {
    id: 1,
    title: "Bulk Carrier Survey - Port of Singapore",
    description: "Comprehensive draught survey for 75,000 MT iron ore cargo",
    category: "Draught Survey",
    year: "2024"
  },
  {
    id: 2,
    title: "Bunker Dispute Resolution",
    description: "Bunker quantity verification leading to successful dispute resolution",
    category: "Bunker Survey",
    year: "2024"
  },
  {
    id: 3,
    title: "Container Vessel Damage Assessment",
    description: "P&I survey for cargo damage claim worth $2M",
    category: "P&I Services",
    year: "2023"
  },
  {
    id: 4,
    title: "Fleet On-Hire Survey Program",
    description: "Conducted on-hire surveys for fleet of 12 vessels",
    category: "On/Off Hire",
    year: "2023"
  },
  {
    id: 5,
    title: "Pre-Purchase Vessel Inspection",
    description: "Detailed condition survey for $50M vessel acquisition",
    category: "Condition Survey",
    year: "2023"
  },
  {
    id: 6,
    title: "Maritime Compliance Consultancy",
    description: "Assisted shipping company with IMO 2020 compliance",
    category: "Consultancy",
    year: "2023"
  }
];

export const certifications = [
  {
    id: 1,
    name: "ISO 9001:2015",
    description: "Quality Management System Certification"
  },
  {
    id: 2,
    name: "IFIA Member",
    description: "International Federation of Inspection Agencies"
  },
  {
    id: 3,
    name: "IIMS Accredited",
    description: "International Institute of Marine Surveying"
  },
  {
    id: 4,
    name: "ICS Certified",
    description: "International Chamber of Shipping"
  }
];

export const team = [
  {
    id: 1,
    name: "Capt. Gurudath Nayak",
    position: "Master Mariner / Marine Superintendent",
    experience: "Over 22 years of experience across both sea-going and shore-based operations.",
    image: "/1st.jpeg"
  },
  {
    id: 2,
    name: "Laxmish Nayak",
    position: "Navigating Officer",
    experience: "12 years of experience at sea.",
    image: "/2nd.jpg"
  },
  {
    id: 3,
    name: "Vignesh Anand Hegde",
    position: "Marine Engineer",
    experience: "4 years of experience at sea.",
    image: "/3rd.jpeg"
  }
];

// Mock email submission
export const submitContactForm = async (formData) => {
  // Simulate API call
  await new Promise(resolve => setTimeout(resolve, 1000));
  console.log("Contact form submitted:", formData);
  return { success: true, message: "Thank you for contacting us. We'll get back to you within 24 hours." };
};

export const submitQuoteRequest = async (formData) => {
  // Simulate API call
  await new Promise(resolve => setTimeout(resolve, 1000));
  console.log("Quote request submitted:", formData);
  return { success: true, message: "Quote request received. Our team will contact you shortly with a detailed quotation." };
};
